<template>
    <main class="main with-sidebar">
        <div class="container">
            <div v-show="visible">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-header">
                            <span class="button-full" @click="toggleModal">{{ $t('button.add') }}</span>
                        </div>
                    </div>
                </div>

				<div class="row">

					<div class="col-lg-12">
						<vuetable ref="categoriesList" :api-url="url"
								  :fields="columns"
								  :muti-sort="true"
								  pagination-path=""
								  @vuetable:load-success="onTableLoaded">
						</vuetable>
					</div>

				</div>

			</div>
			<category-modal :data="category" :show="showModal" @closed="onClosed"></category-modal>
		</div>
    </main>
</template>
<script>
  import Vue from 'vue'
  import _ from 'lodash'
  import Vuetable from '@/components/vuetable/Vuetable'
  import CategoryActions from './CategoryActions'
  import CategoryCell from './CategoryCell'
  import CategoryModal from './CategoryModal'

  Vue.component('category-actions', CategoryActions)
  Vue.component('category-cell', CategoryCell)

  export default {
    name: 'CategoriesPage',
    components: {
      CategoryModal, Vuetable
    },
    data () {
      return {
        visible: false,
        loading: false,
        showModal: false,
        url: '/v1/categories',
        category: {},
        columns: [
          {
            title: 'Id',
            name: 'id',
            sortField: 'id',
            visible: false
          },
          {
            name: '__component:category-cell',
            title: this.$t('label.name'),
            titleClass: 'width-9',
            sortField: 'name'
          },
          {
            name: '__component:category-actions',
            title: '',
            titleClass: 'width-3',
            dataClass: 'table-controls'
          }
        ]
      }
    },
    mounted () {
      this.$events.$on('category-edited', eventData => this.onEdit(eventData))
      this.$events.$on('category-deleted', eventData => this.onDelete(eventData))
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.save()
          }
        })
      },
      cancel () {
        this.category = {}
      },
      onEdit (data) {
        this.category = _.clone(data.category, true)
        this.showModal = true
      },
      onClosed (data) {
        if (data.updated && data.updated === true) {
          Vue.nextTick(() => this.$refs.categoriesList.reload())
        }
        this.showModal = data.show
      },
      onDelete (row) {
        Vue.nextTick(() => this.$refs.categoriesList.reload())
      },
      onTableLoaded () {
        this.visible = true
      },
      toggleModal () {
        this.category = {}
        this.showModal = !this.showModal
      }
    },
    destroyed: function () {
      this.$events.off('category-edited')
      this.$events.off('category-deleted')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Customers/Categories/Categories.vue